import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

import { Product } from 'src/app/domain/Product';
import { Subheader } from '../domain/Subheader';
import { StarredCard1 } from '../domain/StarredCard1';
import { Banner } from '../domain/Banner';
import { FooterSection } from '../domain/Footer';
import { Bubble } from '../domain/Bubble';
import { Post } from '../domain/Post';
import { HeaderLink } from '../domain/Header';
import { StarredProductList } from '../domain/StarredProductList';
import { StarredCard2 } from '../domain/StarredCard2';
import { BenefitsBar } from '../domain/BenefitsBar';
import { Subbanner } from '../domain/Subbanner';
import { UpperBanner } from '../domain/UpperBanner';

export interface CommonResponse {
  headerLinks: HeaderLink[];
  subheader: Subheader;
  benefitsBars: BenefitsBar[];
  footerSections: FooterSection[];
}

@Injectable({
  providedIn: 'root',
})
export class PageService {
  private readonly http = inject(HttpClient);


  public common(): Observable<any> {
    return this.http.get<CommonResponse>('page/common', { params: { context: 'shop' } })
      .pipe(
        map((data: CommonResponse) => data),
        tap()
      );
  }

  public getUpperBanner(): Observable<UpperBanner|null> {
    return this.http.get<UpperBanner|null>('page/upper-banner');
  }

  public getBanners(locationView: number): Observable<Banner[]> {
    return this.http.get<Banner[]>('page/banners', { params: { locationView },})
      .pipe(
        map((data: Banner[]) => data),
        tap()
      );
  }

  public getSubbanner(): Observable<Subbanner> {
    return this.http.get<Subbanner>('page/subbanner').pipe(tap());
  }

  public getBubbles(locationView: number): Observable<Bubble[]> {
    return this.http.get<Bubble[]>('page/bubbles', { params: { locationView },})
      .pipe(
        map((data: Bubble[]) => data),
        tap()
      );
  }

  public getFeaturedProducts(): Observable<Product[]> {
    return this.http.get<Product[]>('page/products-featured').pipe(tap());
  }

  public getStarredCards1(): Observable<StarredCard1[]> {
    return this.http.get<StarredCard1[]>('page/starred-cards-1').pipe(tap());
  }

  public getStarredCards2(): Observable<StarredCard2[]> {
    return this.http.get<StarredCard2[]>('page/starred-cards-2').pipe(tap());
  }

  public getStarredProductLists(locationView: number): Observable<StarredProductList[]> {
    return this.http.get<StarredProductList[]>('page/starred-product-lists', { params: { locationView },})
      .pipe(
        map((data: StarredProductList[]) => data),
        tap()
      );
  }

  public getPosts(): Observable<Post[]> {
    return this.http.get<Post[]>('page/posts').pipe(
      map((posts) => posts.slice(0, 3)),
      tap()
    );
  }
}
